<div>
  <dx-button
    icon="upload"
    text="RESİM Yükle"
    type="normal"
    stylingMode="outlined"
    class="margin"
    (click)="fileInput.click()"
  ></dx-button>

  <div *ngIf="imageSrc">
    <img [src]="imageSrc" [imageSrcFromApi]="imageSrc" alt="" style="max-width: 300px; height: 100px" />
  </div>

  <input
    #fileInput
    type="file"
    [attr.accept]="accept"
    (change)="onFileSelected($event)"
    style="display: none"
  />
</div>
